/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProtectedGroup } from './ProtectedGroup';
import { ProtectedGroupFromJSON, ProtectedGroupFromJSONTyped, ProtectedGroupToJSON } from './ProtectedGroup';

/**
 *
 * @export
 * @interface PaginatedProtectedGroupList
 */
export interface PaginatedProtectedGroupList {
  /**
   *
   * @type {number}
   * @memberof PaginatedProtectedGroupList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedProtectedGroupList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedProtectedGroupList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ProtectedGroup>}
   * @memberof PaginatedProtectedGroupList
   */
  results: Array<ProtectedGroup>;
}

/**
 * Check if a given object implements the PaginatedProtectedGroupList interface.
 */
export function instanceOfPaginatedProtectedGroupList(value: object): value is PaginatedProtectedGroupList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedProtectedGroupListFromJSON(json: any): PaginatedProtectedGroupList {
  return PaginatedProtectedGroupListFromJSONTyped(json, false);
}

export function PaginatedProtectedGroupListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedProtectedGroupList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(ProtectedGroupFromJSON),
  };
}

export function PaginatedProtectedGroupListToJSON(value?: PaginatedProtectedGroupList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(ProtectedGroupToJSON),
  };
}
